export default __webpack_public_path__ + "static/media/Untitled_Artwork 16.9f222497.png";